var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fm-down-select-option"},[(typeof _vm.option.render === 'function')?_c('div',{domProps:{"innerHTML":_vm._s(_vm.option.render(_vm.option))}}):_c('div',[_vm._v(_vm._s(_vm.option.label))])])}
var staticRenderFns = []

export { render, staticRenderFns }